import axios from "axios";
import Swal from "sweetalert2";
import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    env: "production",
    config: {
      production: {
        // yasale.zwiz.ai
        liffid: "1656136806-YwgE9RjR",
        scandit:
          "AZHhzb6BKhyIO6iEgBAEOm8kT1okIF0i+19oxIclt/WxN2DKMlAKH85ynkgWKpszEUSt76M3R3RQBMuQEiS+N5EJCW5hbogSMHJEMcpgQ1KDQRe3K2xl76FmWNWlWsU+O3OwoMV/aMAlXcLE3SpNMkdBVwfRDQIjBAJUONJpr1NeMeru40E7jDWLVOsPpd5sljTBtujQfg5ENbeuc1JntRHZHNBG5tsDBhW/WNjd/IlryxT+68fQJzeqy4/ing+9n1N64loGM+CqfH/Cf5SMum5OQijyAV7ww2JZnizwfZo1ZTIATNwpNrPQ4zmsYFYgLjJS8mJdcy8k58EcPhT2X7QLS+9+dy+m6FYNqxyS9I3EGyzyrpVzkNycYK16h9ulgVagd2ygX6LPZwPxt2wMLv0vt69rE04c8K/HGmK5cs6Gp1UDBcK+jqGI4KdenCZ5tsI9J/n5otjcull89xmga+ppr6VmwxNozYEJP6t4Q/Wb32CXJKEWVz9Ht6epOWQDwG55sODTu5S2Q4oEh8t9IxLF9uyGUfId1cVDjQh9jQ80sCFf631iIceIrDNMZBlzGrkTFnGMBB73b3E4TE9NFWhIJIzXGPxE3aDZB6GkzR9yJu5rcdoEV0GTMI0KVclQejDH1V+aJ6fp5iPs8LsYFC86UoTqQ22uUEgh06KoVmJv1NvajQYUekzkaZNfMYEibH8DI2ayJ2JPVZ0v1Lo3bM/mciuXpM6Wl7eVfGKFcYdFsnPKvEI4vRCBbc4MYsCh1RbIZvq9Pzt13XEfjHJytUTICaCDj18GFkTsitBWUCpWSRaBWa9LcFZwSuNGCD1fcDaBYVgShw9Sg/Ld",
      },
      development: {
        // uat.yasale.zwiz.app
        liffid: "1656136806-drBy0Y7Y",
        scandit:
          "ASSR/SgWDPfoP6i7FjuSgIozinACOavw31nsQuVv1Qg4VUn67GkEb4RnNPBpNwSf7VuF4kpdHAQ9UGn15Tm6fhptUdfCftt9S1cvxW53X/ufSlZZkHEUX1FxLyxgTbnVd2onPgJbInrtSucc+2smSxV9krlqBtr20Sfx58xDH6W0P3SAKoxDPPnM0IY9Kp+HPWdmK4X7dJhcBf5qcQ4wrxquit1cZABorbjAbgmZl8GgsJI7sVvPtmwn5haeT3SWIg1UHjhMnsUhmLywu54OlzkkZXK2FS9OKEidbPOG3L67frSL2dX1oiJc6m7FguFK3NM3VGA1GnRuVJAUBemdrlLsz0bUjpiI2Cen6oEgFuXgZr0DuuT62fBeDB0Q4fdZM708QOdHR+lIa2LarZZL1NxweW62/UFBLiALoeA3Uv7WOz3qEAnLFFhbhK+xO5CRIvxRNzrr4Zueg6BA4zyyi/RzLH1ARqgIO7yCEF3zTikPPTlOdYv2QYsJJN9H9aj8pLf9BL6On0bhW4ZnYR8SJEOD/QvHUiJScqePIK0pujd7XM4+iue2i+Jhm/tejS2P/Vaot2Gff0te2mOtjymh5TrzSu79wRNFvHrpqABGmFP9JF9JaX8evPB8dNsq+RvepEtPCDaAJflGSyaS/Gp4gJWKiKXCe7zNPp+OFUyAsBAEb+9cGvU8EBL2ELrGOSNPJ8WtLN3BqTNv8hsjm7ZDh3vUVPfIL+tKi250pMQwXROqtbmNZY6bU3YOKhFAtSnwLCF8t8Icrm4xSjBFxAjlo0Zko5VS7aLCnAjmcyoC3bHLeqwha6IQCbQqP5mK0nFyrNaOi/ZmzvWSxL95RybqSKSi8/g=",
      },
      localhost: {
        // https://localhost:8080/
        liffid: "1656136806-xkyEakQk",
        scandit:
          "ASSR/SgWDPfoP6i7FjuSgIozinACOavw31nsQuVv1Qg4VUn67GkEb4RnNPBpNwSf7VuF4kpdHAQ9UGn15Tm6fhptUdfCftt9S1cvxW53X/ufSlZZkHEUX1FxLyxgTbnVd2onPgJbInrtSucc+2smSxV9krlqBtr20Sfx58xDH6W0P3SAKoxDPPnM0IY9Kp+HPWdmK4X7dJhcBf5qcQ4wrxquit1cZABorbjAbgmZl8GgsJI7sVvPtmwn5haeT3SWIg1UHjhMnsUhmLywu54OlzkkZXK2FS9OKEidbPOG3L67frSL2dX1oiJc6m7FguFK3NM3VGA1GnRuVJAUBemdrlLsz0bUjpiI2Cen6oEgFuXgZr0DuuT62fBeDB0Q4fdZM708QOdHR+lIa2LarZZL1NxweW62/UFBLiALoeA3Uv7WOz3qEAnLFFhbhK+xO5CRIvxRNzrr4Zueg6BA4zyyi/RzLH1ARqgIO7yCEF3zTikPPTlOdYv2QYsJJN9H9aj8pLf9BL6On0bhW4ZnYR8SJEOD/QvHUiJScqePIK0pujd7XM4+iue2i+Jhm/tejS2P/Vaot2Gff0te2mOtjymh5TrzSu79wRNFvHrpqABGmFP9JF9JaX8evPB8dNsq+RvepEtPCDaAJflGSyaS/Gp4gJWKiKXCe7zNPp+OFUyAsBAEb+9cGvU8EBL2ELrGOSNPJ8WtLN3BqTNv8hsjm7ZDh3vUVPfIL+tKi250pMQwXROqtbmNZY6bU3YOKhFAtSnwLCF8t8Icrm4xSjBFxAjlo0Zko5VS7aLCnAjmcyoC3bHLeqwha6IQCbQqP5mK0nFyrNaOi/ZmzvWSxL95RybqSKSi8/g=",
      },
    },
    currentPoint: 0,
    backgroundColor: "#fff",
    serverUrl: "https://api-enterprise.zwiz.app/",
    query: {},
    redirectview: "",
    member: {},
    profile: {},
    forgetPasswordData: {},
    headertext: "",
    input: {
      shopDistrict: "",
      shopProvince: "",
      shopSubDistrict: "",
      shopPostcode: "",
    },
    ref: null,
  },
  mutations: {},
  actions: {
    sendMessage({ state }, message) {
      var vm = this;
      return new Promise(async (resolve) => {
        var url = state.serverUrl + "zwiz-pushmsg-webbrowser";
        var data = {
          pageid: state.query.pageid,
          userid: state.userid,
          message,
        };
        if (await window.liff.isInClient()) {
          try {
            await window.liff.sendMessages([
              {
                text: message,
                type: "text",
              },
            ]);
            resolve();
          } catch (error) {
            alert(JSON.stringify(error));
            alert(JSON.stringify(error.message));
          }
        } else {
          axios
            .post(url, data, {
              headers: {
                AUTHORIZATION: "Bearer xxx xxx",
              },
            })
            .then(async (response) => {
              if (response.data.responsecode == 200) {
                resolve();
              } else {
                if (response.data.reason) {
                  await Swal.fire({
                    text: response.data.reason,
                  });
                  resolve();
                }
              }
            });
        }
      });
    },
    messengerClose() {
      MessengerExtensions.requestCloseBrowser(
        function success() {},
        function error() {
          window.close();
        }
      );
    },
  },
  modules: {},
});
